import { render, staticRenderFns } from "./ProductCase.vue?vue&type=template&id=52715332&scoped=true"
var script = {}
import style0 from "./ProductCase.vue?vue&type=style&index=0&id=52715332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52715332",
  null
  
)

export default component.exports